const areaColors = [
  "#DDEAF8",
  "#FBE5D9",
  "#F8E0E0",
  "#EBDDF1",
  "#E0ECE0",
  "#D9ECEE",
];

export const pickAreaColorFromIndex = (index: number): string => {
  return areaColors[index] ?? "#FFF";
};
